import dayjs from 'dayjs';
import { useContext } from 'react';
import { InboundContext } from '../../context/InboundContext';
import { formatCurrency } from '../../utils/global';
import Ftux from '../common/Ftux/Ftux';
import styles from './tables.module.css';

type PaymentTableProps = {
  tableBody: any[];
  currentTab: string;
};

const getStatusDetail = (status: string) => {
  switch (status) {
    case 'pending':
      return { backgroundColor: '#FBEFEF', color: '#D04E4E', name: 'Pending' };
    case 'completed':
      return { backgroundColor: '#EBF8E7', color: '#40972B', name: 'Paid' };
    default:
      return { backgroundColor: '#FBEFEF', color: '#D04E4E', name: 'Pending' };
  }
};

const getTypeDetail = (status: string) => {
  switch (status) {
    case 'goAffPro':
      return { backgroundColor: '#12B829b3', color: '#fff', name: 'GoAffPro' };
    case 'Log Payment':
      return { backgroundColor: '#7357E966', color: '#fff', name: 'Log Payment' };
    default:
      return { backgroundColor: '#6670851a', color: '#667085', name: 'in draft' };
  }
};

export default function PaymentTable({ tableBody, currentTab }: PaymentTableProps) {
  const { defaultCurrency } = useContext(InboundContext);
  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>Name</th>
          <th>Username</th>
          {currentTab === 'pending' && (
            <>
              <th>Sales</th>
              <th>Pending Commission</th>
            </>
          )}
          {currentTab === 'completed' && (
            <>
              <th>Paid Amount</th>
              <th>Date of Payment</th>
              <th>Type</th>
            </>
          )}
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        {tableBody && tableBody?.length > 0 ? (
          tableBody.map((row, index) => {
            const status = getStatusDetail(row.status);
            const type = getTypeDetail(row?.tag === 'Log Payment' ? 'Log Payment' : 'goAffPro');

            return (
              <tr key={index}>
                <td>{row.name}</td>
                <td>{row.username}</td>
                {currentTab === 'pending' && (
                  <>
                    <td>{formatCurrency(row.sales, defaultCurrency)}</td>
                    <td>{formatCurrency(row.amount, defaultCurrency)}</td>
                  </>
                )}
                {currentTab === 'completed' && (
                  <>
                    <td>{formatCurrency(row.amount, defaultCurrency)}</td>
                    <td>{dayjs(row?.date).format('DD/MM/YY')}</td>
                    <td>
                      <span
                        style={{
                          padding: '6px 12px',
                          borderRadius: '100px',
                          textTransform: 'capitalize',
                          backgroundColor: type.backgroundColor,
                          color: type.color,
                          fontSize: 13,
                          width: 300,
                        }}
                      >
                        {type.name}
                      </span>
                    </td>
                  </>
                )}
                <td>
                  <span
                    style={{
                      padding: '6px 12px',
                      borderRadius: '100px',
                      textTransform: 'capitalize',
                      backgroundColor: status.backgroundColor,
                      color: status.color,
                      fontSize: 13,
                    }}
                  >
                    {status.name}
                  </span>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={currentTab === 'completed' ? 6 : 5} style={{ background: 'transparent' }}>
              <div className={styles.ftuxContainer}>
                <Ftux
                  emoji="💸"
                  title={currentTab === 'completed' ? 'No Payments Completed Yet' : 'No Pending Payments for now'}
                  text={
                    currentTab === 'completed'
                      ? 'Once you pay your ambassadors, they will show up here!'
                      : 'There are no pending payments, please check in later! You can always log a manual payment though!'
                  }
                />
              </div>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}
